module.exports = __webpack_public_path__ + "static/media/check-circle-regular.20f8f15b.svg";